import React,{useEffect,useState} from "react";
import axios from "axios";
import { baseUrl, baseimgUrl } from "../Univ";
import { Link } from "react-router-dom";
function AlsoBought({productId}){

  const [items,setItems]=useState([]);

  useEffect(()=>{
    axios.get(baseUrl+`also-bought/${productId}/`)
    .then(res=>setItems(res.data));
  },[productId]);

  if(items.length===0) return null;

  return(
    <div className="mt-5">

      <h4>Customers Also Bought</h4>

      <div className="row">

        {items.map(p=>(
          <div key={p.id} className="col-md-3">

            <div className="card p-2">
       <Link to={`/product/${p.id}`}>
                    <img
                      src={`${baseimgUrl}${p.images?.[0]?.image}`}
                      alt={p.name}
                      className="product-img"
                      style={{ width: "100%", objectFit: "contain" }}
                    />
                  </Link>

              <h6>{p.name}</h6>
              <p>₹{p.price}</p>
            </div>

          </div>
        ))}

      </div>

    </div>
  );
}

export default AlsoBought;
